module.exports = __webpack_public_path__ + "static/media/10.9a79bb7b.png";